module.exports = __webpack_public_path__ + "img/home-wxcode.5a13db64.png";